/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconRubberStamp = createReactComponent("outline", "rubber-stamp", "IconRubberStamp", [["path", { "d": "M21 17.85h-18c0 -4.05 1.421 -4.05 3.79 -4.05c5.21 0 1.21 -4.59 1.21 -6.8a4 4 0 1 1 8 0c0 2.21 -4 6.8 1.21 6.8c2.369 0 3.79 0 3.79 4.05z", "key": "svg-0" }], ["path", { "d": "M5 21h14", "key": "svg-1" }]]);

export { IconRubberStamp as default };
//# sourceMappingURL=IconRubberStamp.mjs.map
